module.exports = __webpack_public_path__ + "img/img3.7b4cd4eb.jpg";